import { useKeyboardHeight } from "../../../hooks/use-keyboard-height";
import { cn } from "../../../lib/utils";

export function StepFooter({ children }: { children: React.ReactNode }) {
  const { isKeyboardOpen } = useKeyboardHeight();

  // The blurred translucent band is provided by the overlay wrapper in
  // OnboardingPage; this only owns the inner spacing (and shrinks its bottom gap
  // when the keyboard is open).
  return (
    <div
      className={cn(
        "flex flex-col gap-2 px-4 pt-4",
        isKeyboardOpen ? "pb-1" : "pb-12"
      )}
    >
      {children}
    </div>
  );
}
